//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
export default {
  name: 'ConfirmSurvey',
  components: {
    FibSurvey: require("../settings/SelectSurvey").default
  },
  data: function data() {
    return {
      showConfirmation: false,
      showSurvey: false
    };
  },
  computed: {
    defaultTemplate: get('settings/defaultTemplate'),
    name: get('surveys/name'),
    selectedTemplate: sync('settings/selectedTemplate'),
    surveyCount: get('surveys/surveyCount')
  },
  watch: {
    defaultTemplate: {
      immediate: true,
      handler: function handler(template) {
        this.setTemplate(template);
      }
    }
  },
  methods: {
    setTemplate: function setTemplate(defaultTemplate) {
      this.selectedTemplate = defaultTemplate;

      if (this.selectedTemplate) {
        this.showSurvey = false;
        this.showConfirmation = true;
      } else {
        this.showConfirmation = false;
        this.showSurvey = true;
      }
    },
    confirmed: function confirmed() {
      this.showConfirmation = false;
      this.$emit('done', {
        name: 'survey',
        result: true
      });
    },
    select: function select() {
      this.selectedTemplate = null;
      this.showConfirmation = false;
      this.showSurvey = true;
    },
    selected: function selected() {
      this.showSurvey = false;
      this.showConfirmation = true;
    }
  }
};